import { render, staticRenderFns } from "./approver_list.vue?vue&type=template&id=85d5825c&scoped=true&"
import script from "./approver_list.vue?vue&type=script&lang=js&"
export * from "./approver_list.vue?vue&type=script&lang=js&"
import style0 from "./approver_list.vue?vue&type=style&index=0&id=85d5825c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5825c",
  null
  
)

export default component.exports